/******************************************************************************
 * MachineLabelEditor: inline rename for one machine type or brand label.
 *****************************************************************************/

/* Imports */
import { useState } from "react";
import { t } from "i18next";
import { Button } from "@material-tailwind/react";
/***/

/**
* MachineLabelEditor: show a label's rename control
* @param label - the label currently stored
* @param testId - suffix for data-testid
* @param onSave - persists the new label; reject to keep the field open
*/
export default function MachineLabelEditor({
  label,
  testId,
  onSave
}: {
  label: string,
  testId: string,
  onSave: (label: string) => Promise<void>
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(label);
  const [saving, setSaving] = useState(false);

  const open = () => {
    setDraft(label);
    setEditing(true);
  };

  const save = () => {
    const next = draft.trim().replace(/\s+/g, " ");
    if (next === label.trim().replace(/\s+/g, " ")) {
      setEditing(false);
      return;
    }
    setSaving(true);
    onSave(next)
      .then(() => setEditing(false))
      .catch(() => {})
      .finally(() => setSaving(false));
  };

  if (!editing) {
    return (
      <Button size="sm" variant="text" data-testid={"rename-" + testId} onClick={open}>
        {t("admin:tools.machineDedup.rename.button")}
      </Button>
    );
  }

  return (
    <span className="flex items-center gap-2">
      <input
        data-testid={"rename-input-" + testId}
        value={draft}
        aria-label={t("admin:tools.machineDedup.rename.button")}
        onChange={(event) => setDraft(event.target.value)}
        className="border border-blue-gray-200 rounded px-2 py-1 text-sm" />
      <Button size="sm" data-testid={"rename-save-" + testId} disabled={saving} onClick={save}>
        {t("admin:tools.machineDedup.rename.save")}
      </Button>
      <Button size="sm" variant="outlined" data-testid={"rename-cancel-" + testId}
        disabled={saving} onClick={() => setEditing(false)}>
        {t("common:cancel")}
      </Button>
    </span>
  );
}
/***/
